import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../services/directory.service';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {Attachment, EmailAttachment} from '../../../types/email-data.types';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {AuthTokenService} from 'app/services/auth-token.service';
import {EmailService} from '../../../services/email.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'send-invitation-modal',
    templateUrl: './send-invitation-modal.component.html',
    styleUrls: ['./send-invitation-modal.component.scss']
})

export class SendInvitationModalComponent implements OnInit {
    message = '';
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    corpNumber = null;
    somethingChanged = false;
    saveAsDefault = false;
    sendLater = false;
    placeholders = [
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[INVITATION_LINK]]',
        '[[MY_SIGNATURE]]',
        '[[DATA_CONFIRMATION_LINK]]',
        '[[MCC_INVITATION_LINK]]',
        '[[COMMON_ELEMENTS_FEE]]',
    ];
    startDate = new Date();
    currentTime = new Date();
    time = moment().format('h:mm A');
    disabledFileInput = false;
    spinnerShow = false;
    attachments = [];
    alternativeEmails = [];
    emailTo = '';

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService,
        public es: EmailService,
        private http: Http,
        private authTokenService: AuthTokenService
    ) {}

    ngOnInit() {
        this.message = this.directoryService.sendInvitationMessageData.inviteTemplate;
        this.corpNumber = this.directoryService.sendInvitationMessageData.corpNumber;
        this.alternativeEmails = JSON.parse(JSON.stringify(this.directoryService.sendInvitationMessageData.recipients[0].alternativeEmails
            .filter(item => !item.isBadEmail)));
        this.emailTo = JSON.parse(JSON.stringify(this.directoryService.sendInvitationMessageData.recipients[0].email));

        setTimeout(() => this.initTimePicker());
        this.initSummernote();
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (userData.company)
            this.getCompanySettings(userData.company.id);
    }

    updateEmail(value) {
        this.emailTo = value;
    }

    onSubmit(form: NgForm): void {
        const contentName = this.directoryService.sendInvitationMessageData.isInvitation ? 'Invitation email' : 'Message';
        if (!this.directoryService.sendInvitationMessageData.subject) {
            toastr.error('Subject must not be empty.');
            return;
        }
        if (!this.message) {
            toastr.error(`${contentName} must not be empty.`);
            return;
        }
        if (this.directoryService.sendInvitationMessageData.isInvitation && !this.message.includes('INVITATION_LINK')) {
            toastr.error('[[INVITATION_LINK]] or [[MCC_INVITATION_LINK]] placeholder must be present in the message.');
            return;
        }
        if (this.sendLater && (!this.startDate || !this.time)) {
            toastr.error(`Date and Time fields must not be empty.`);
            return;
        }
        this.disabledSubmit = true;
        this.showSpinner = true;
        const data = JSON.parse(JSON.stringify(this.directoryService.sendInvitationMessageData));
        if (this.saveAsDefault) {
            const url = `/v1/corporation_number/${this.corpNumber}.json`;
            this.api.patch('domainBD', url, {inviteTemplate: this.message}).subscribe(
                (response) => toastr.success('Corporate invitation template has been updated successfully.'),
                error => this.api.errorHandler(error, 'Failed to update corporate invitation template.')
            );
        }
        data.message = this.message;
        if (this.sendLater)
            data.scheduleDate = this.getDateTimeFromForm();
        if (this.attachments.length > 0)
            data.attachments = this.getAttachmentsData();

        data.recipients[0].email = this.emailTo;

        delete data.corpNumber;
        delete data.inviteTemplate;
        delete data.isInvitation;
        delete data.alternativeEmails;
        this.es.sendEmail(data)
            .subscribe(
                (response) => {
                    toastr.success(`${contentName} has been sent successfully.`);
                    if (this.directoryService.sendInvitationMessageData.isInvitation)
                        this.directoryService.selectedItemData.isInvited = 1;
                    this.hideModal(form, true);
                },
                error => {
                    this.api.errorHandler(error, `Failed to send ${contentName.toLowerCase()}`);
                    this.disabledSubmit = false;
                    this.showSpinner = false;
                }
            );
    }

    hideModal(form, closeOnSubmit?) {
        if (this.somethingChanged && !closeOnSubmit) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.directoryService.showSendInvitationModal = false;
                    this.directoryService.sendInvitationMessageData = null;
                }
            );
        } else {
            this.directoryService.showSendInvitationModal = false;
            this.directoryService.sendInvitationMessageData = null;
        }
    }

    initSummernote() {
        document.body.classList.add('body-upload-file-email');
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.somethingChanged = true;
                    this.message = contents;
                },
                onImageUpload: files => this.es.uploadFile(files, summernote),
                onMediaDelete: target => this.es.deleteFile(target, summernote)
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr', 'picture']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initTimePicker() {
        $('#timepicker').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(): void {
        $('#timepicker').timepicker('showWidget');
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.startDate);
        const time = this.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return new Date(moment(date).format().slice(0, -6) + '-00:00');
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (Attachment.isNotAvailableType(file.name)) {
            toastr.warning('Attachment\'s type not supported.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.spinnerShow = true;
        this.disabledFileInput = true;
        this.disabledSubmit = true;
        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Attachment path should not be blank.');
                    return;
                }
                const attachment = new Attachment(file.name, file.size, res.path);
                this.attachments.push(attachment);
                this.disabledSubmit = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerShow = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            },
            () => {
                this.spinnerShow = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            }
        );

    }

    removeFile(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => this.attachments.splice(i, 1)
        );
    }

    getAttachmentsData(): EmailAttachment[] {
        return this.attachments.map(at => ({name: at.name, fileSize: at.fileSize, path: at.path}));
    }

    getCompanySettings(id) {
        const url = `/api/v1/company_service_settings/${id}`;
        this.es.api.get('domainEmails', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                if (body.emailSender)
                    this.directoryService.sendInvitationMessageData.sender = body.emailSender;
                if (body.emailSenderName)
                    this.directoryService.sendInvitationMessageData.senderName = body.emailSenderName;
            }, error => this.es.api.errorHandler(error, 'Failed to get sender info.')
        );
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/directory/send-invitation-modal/send-invitation-modal.component.ts